'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canvasUtils = exports.Canvas = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _api = require('./api');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Canvas = exports.Canvas = function () {
  function Canvas(opts) {
    _classCallCheck(this, Canvas);

    opts = opts || {
      token: {}
    };

    if (!opts.id) {
      throw new Error('No id supplied to Canvas constructor');
    }

    this.id = opts.id;
    this.projectId = opts.projectId;
    this.token = opts.token;
    this._saved = true;
  }

  _createClass(Canvas, [{
    key: '_refreshToken',
    value: function _refreshToken() {
      return _api.tokenProvider.getAuth(this.id, this.projectId).then(function (response) {
        return {
          token: response.body.token,
          expires: new Date(Date.parse(response.body.exp))
        };
      }).then(function (token) {
        this.token = token;
        return this;
      }.bind(this));
    }
  }, {
    key: '_ensureActiveToken',
    value: function _ensureActiveToken() {
      console.groupCollapsed('Easel Token');
      console.log('looking for a valid token');
      var now = new Date(Date.now());
      var thePromise;

      if (this.token.expires > now) {
        console.log('existing token is valid');
        thePromise = _bluebird2.default.resolve(this);
      } else {
        console.log('no valid token found');
        thePromise = this._refreshToken();
      }

      thePromise.then(function (something) {
        console.groupEnd();
        return something;
      });
      return thePromise;
    }
  }, {
    key: '_create',
    value: function _create(data) {
      var that = this;
      return this._ensureActiveToken().then(function (canvas) {
        console.log('creating new canvas in Easel');
        return _api.easel.create(canvas.token.token, data);
      }).then(function (canvas) {
        that._saved = true;
        return that;
      });
    }
  }, {
    key: '_save',
    value: function _save(data) {
      return this._ensureActiveToken().then(function (canvas) {
        console.log('saving data to Easel');
        return _api.easel.save(canvas.token.token, canvas.id, data).then(function (data) {
          console.log('saving data to Easel - done');
          return data;
        });
      });
    }
  }, {
    key: 'store',
    value: function store(data) {
      if (data.canvas.id !== this.id) {
        // just a sanity check
        throw new Error('Canvas.id does not match data.id, data.canvas.id: ' + data.canvas.id + ', this.id: ' + this.id);
      }

      if (!this._saved) {
        return this._create(data);
      } else {
        return this._save(data);
      }
    }
  }, {
    key: 'fetch',
    value: function fetch() {
      return this._ensureActiveToken().then(function (canvas) {
        return _api.easel.fetch(canvas.token.token, canvas.id);
      }).then(function (response) {
        return response.body;
      });
    }
  }, {
    key: 'fetchCode',
    value: function fetchCode(language) {
      return this._ensureActiveToken().then(function (canvas) {
        return _api.easel.fetchCode(canvas.token.token, canvas.id, language);
      }).then(function (response) {
        return response.body;
      });
    }
  }, {
    key: 'delete',
    value: function _delete() {
      if (!this._saved) {
        throw new Error('Can not delete a canvas that has not yet been saved');
      }

      return this._ensureActiveToken().then(function (canvas) {
        return _api.easel.delete(canvas.id);
      });
    }
  }], [{
    key: 'new',
    value: function _new(projectId) {
      // Interacts with Marvel to reserve a canvas id
      // and then returns a promise resolving to a
      // Canvas object
      console.groupCollapsed('Easel Token');
      return _api.tokenProvider.newCanvas(projectId).then(function (response) {
        console.groupEnd(); // Easel Token ^^^

        return {
          id: response.body.canvas_id,
          projectId: projectId,
          token: {
            token: response.body.token,
            expires: new Date(Date.parse(response.body.exp))
          }
        };
      }).then(function (data) {
        var c = new Canvas(data);
        c._saved = false;
        return c;
      });
    }
  }, {
    key: 'newComponent',
    value: function newComponent() {
      // Interacts with Marvel to reserve a canvas id and then returns a
      // promise resolving to a Canvas object
      return _api.tokenProvider.newComponent().then(function (response) {
        return {
          id: response.body.canvas_id,
          token: {
            token: response.body.token,
            expires: new Date(Date.parse(response.body.exp))
          }
        };
      }).then(function (data) {
        var c = new Canvas(data);
        c._saved = false;
        return c;
      });
    }
  }, {
    key: 'newFromContent',
    value: function newFromContent(projectId, contentId) {
      // Interacts with Marvel to reserve a canvas id
      // and then returns a promise resolving to a
      // Canvas object
      console.groupCollapsed('New Content Easel');
      return _api.tokenProvider.newCanvasForContent(projectId, contentId).then(function (response) {
        console.groupEnd(); // New Content Easel ^^^

        console.groupCollapsed('Easel Token');
        console.log(response.body);
        return _api.tokenProvider.getAuth(response.body.es_canvas_id, projectId);
      }).then(function (response) {
        console.groupEnd();
        return {
          id: response.body.canvas_id,
          projectId: projectId,
          token: {
            token: response.body.token,
            expires: new Date(Date.parse(response.body.exp))
          }
        };
      }).then(function (data) {
        var c = new Canvas(data);
        c._saved = false;
        return c;
      });
    }
  }, {
    key: 'load',
    value: function load(projectId, id) {
      console.groupCollapsed('Easel Token');
      return _api.tokenProvider.getAuth(id, projectId).then(function (response) {
        console.groupEnd(); // Easel Token ^^^

        return {
          id: response.body.canvas_id,
          projectId: projectId,
          token: {
            token: response.body.token,
            expires: new Date(Date.parse(response.body.exp))
          }
        };
      }).then(function (data) {
        return new Canvas(data);
      });
    }
  }]);

  return Canvas;
}();

var canvasUtils = exports.canvasUtils = {
  uploadDataUri: function uploadDataUri(dataUri) {
    var uuid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (dataUri.match(/^http/)) {
      // It's HTTP!
      return _api.images.uploadFromURL(dataUri, uuid);
    }

    var parts = dataUri.split(',');
    var type = parts[0].split(':')[1].split(';')[0];
    var byteString = atob(parts[1]);
    var aBuffer = new ArrayBuffer(byteString.length);
    var intArray = new Uint8Array(aBuffer);

    for (var i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }

    var blob = new Blob([intArray], {
      type: type
    });
    return _api.images.upload(blob, uuid);
  }
};